module.exports = __webpack_public_path__ + "img/logo.bc2e4f58.png";